import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { buildLoginPath } from './authRedirect';

export const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }
  return (
    error.name === 'ChunkLoadError' ||
    /Failed to fetch dynamically imported module|Loading chunk [\d]+ failed/i.test(
      error.message,
    )
  );
};

type AppRecoveryFallbackProps = {
  title?: string;
  message?: string;
};

export const AppRecoveryFallback = ({
  title = 'Something went wrong. Try refreshing the page.',
  message = 'If the problem continues, use Contact in Settings and describe what you were doing.',
}: AppRecoveryFallbackProps) => {
  const handleExit = () => {
    const returnTo = `${window.location.pathname}${window.location.search}`;
    window.location.assign(buildLoginPath(returnTo));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        px: 3,
        py: 4,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, maxWidth: 480 }}
      >
        {message}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Refresh
        </Button>
        <Button variant="outlined" onClick={handleExit}>
          Exit
        </Button>
      </Stack>
    </Box>
  );
};
